module.exports = __webpack_public_path__ + "static/media/md-laptop.085b1d76.svg";